import React, { ComponentProps } from "react";

export default function HourglassIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <rect width="60" height="60" rx="30" fill="#FAFAFA" />
      <mask
        id="mask0_6726_408963"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="40"
        height="40"
      >
        <rect x="10" y="10" width="40" height="40" fill="#C16200" />
      </mask>
      <g mask="url(#mask0_6726_408963)">
        <path
          d="M29.9998 28.0422C31.8814 28.0422 33.4792 27.3853 34.7931 26.0714C36.1073 24.7575 36.7643 23.1597 36.7643 21.278V16.3468H23.2352V21.278C23.2352 23.1597 23.8923 24.7575 25.2064 26.0714C26.5203 27.3853 28.1181 28.0422 29.9998 28.0422ZM17.8435 47.3264C17.3296 47.3264 16.895 47.1483 16.5398 46.7922C16.1845 46.4361 16.0068 46.0004 16.0068 45.4851C16.0068 44.9698 16.1845 44.5357 16.5398 44.1826C16.895 43.8298 17.3296 43.6534 17.8435 43.6534H19.5627V38.7001C19.5627 36.869 20.027 35.1766 20.9556 33.623C21.8845 32.0691 23.1411 30.8615 24.7256 30.0001C23.1411 29.1201 21.8845 27.9032 20.9556 26.3493C20.027 24.7957 19.5627 23.1034 19.5627 21.2726V16.3468H17.8435C17.3296 16.3468 16.895 16.1687 16.5398 15.8126C16.1845 15.4565 16.0068 15.0212 16.0068 14.5068C16.0068 13.9926 16.1845 13.5559 16.5398 13.1968C16.895 12.8379 17.3296 12.6584 17.8435 12.6584H42.156C42.6688 12.6584 43.1057 12.8396 43.4668 13.2018C43.8277 13.564 44.0081 14.0023 44.0081 14.5168C44.0081 15.0309 43.8277 15.4646 43.4668 15.8176C43.1057 16.1704 42.6688 16.3468 42.156 16.3468H40.4527V21.2726C40.4527 23.1034 39.9896 24.7957 39.0635 26.3493C38.1374 27.9032 36.8795 29.1201 35.2898 30.0001C36.8795 30.8615 38.1374 32.0691 39.0635 33.623C39.9896 35.1766 40.4527 36.869 40.4527 38.7001V43.6534H42.156C42.6688 43.6534 43.1057 43.8315 43.4668 44.1876C43.8277 44.5437 44.0081 44.9794 44.0081 45.4947C44.0081 46.01 43.8277 46.444 43.4668 46.7968C43.1057 47.1498 42.6688 47.3264 42.156 47.3264H17.8435Z"
          fill="#C16200"
        />
      </g>
    </svg>
  );
}
